import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-dd0b8112"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "manifold m-inventory"
}
const _hoisted_2 = { class: "m-inventory-meter" }
const _hoisted_3 = { class: "m-inventory-info" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }

import { computed } from "vue";
import { useStore } from "@/composables/useStore";

interface InventoryProps {
  forward?: boolean;
  format?: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Inventory',
  props: {
    forward: { type: Boolean },
    format: {}
  },
  setup(__props: any) {

const props = __props;

const store = useStore();


const inventoryRatio = computed(() => {
  if (props.forward) {
    return 100 - (store.tokenRemaining / store.tokenMax) * 100;
  }

  return (store.tokenRemaining / store.tokenMax) * 100;
});

const text = computed(() => {
  let numerator = store.tokenRemaining;

  if (props.forward) {
    numerator = store.tokenMax - numerator;
  }

  if (props.format) {
    let text = props.format;
    text = text.replace("NNNN", numerator.toString());

    if (props.format.includes("DDDD")) {
      text = text.replace("DDDD", store.tokenMax.toString());
    }

    return text;
  }

  return `${numerator} of ${store.tokenMax} Left`;
});

return (_ctx: any,_cache: any) => {
  return (_unref(store).loaded)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", {
            style: _normalizeStyle({ width: `${inventoryRatio.value}%` })
          }, null, 4)
        ]),
        _createElementVNode("div", _hoisted_3, [
          (_unref(store).tokenRemaining > 0)
            ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(text.value), 1))
            : (_openBlock(), _createElementBlock("span", _hoisted_5, "Sold out"))
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})